// Opciones de la interfaz de filtrado (etiquetas legibles + valores que envía la API).
// Centralizado para reutilizarse en FilterView en todas las secciones del catálogo.

export const DEPARTMENT_OPTIONS = [
  'Capital',
  'General Alvear',
  'Godoy Cruz',
  'Guaymallén',
  'Junín',
  'La Paz',
  'Las Heras',
  'Lavalle',
  'Luján de Cuyo',
  'Maipú',
  'Malargüe',
  'Rivadavia',
  'San Carlos',
  'San Martín',
  'San Rafael',
  'Santa Rosa',
  'Tunuyán',
  'Tupungato',
];

export const PROPERTY_TYPE_OPTIONS = [
  { value: 'departamento', label: 'Departamento' },
  { value: 'casa', label: 'Casa' },
  { value: 'ph', label: 'PH' },
  { value: 'local', label: 'Local' },
  { value: 'terrenos y lotes', label: 'Terrenos y lotes' },
  { value: 'campos y chacras', label: 'Campos y chacras' },
  { value: 'fondo de comercio', label: 'Fondo de comercio' },
  { value: 'cochera', label: 'Cochera' },
  { value: 'oficina', label: 'Oficina' },
  { value: 'galpon', label: 'Galpón' },
  { value: 'quinta', label: 'Quinta' },
  { value: 'otros', label: 'Otros' },
];

export const PROPERTY_STATE_OPTIONS = [
  { value: 'aEstrenar', label: 'A estrenar' },
  { value: 'enConstruccion', label: 'En construcción' },
  { value: 'refaccionado', label: 'Refaccionado' },
  { value: 'aRefaccionar', label: 'A refaccionar' },
  { value: 'excelente', label: 'Excelente' },
  { value: 'muyBueno', label: 'Muy bueno' },
  { value: 'bueno', label: 'Bueno' },
  { value: 'regular', label: 'Regular' },
];

export const CURRENCY_OPTIONS = [
  { value: 'USD', label: 'USD (Dólares)' },
  { value: 'ARS', label: 'ARS (Pesos)' },
];

export const ORDER_BY_OPTIONS = [
  { value: '', label: 'Relevancia' },
  { value: 'price', label: 'Precio: menor a mayor' },
  { value: 'priceDesc', label: 'Precio: mayor a menor' },
  { value: 'updatedAt', label: 'Última actualización' },
  { value: 'createdAt', label: 'Más recientes' },
];

// Conteos de ambientes (selects numéricos). El backend filtra por valor exacto.
export const COUNT_FIELDS = [
  { name: 'rooms', label: 'Dormitorios' },
  { name: 'bathrooms', label: 'Baños' },
  { name: 'environments', label: 'Ambientes' },
  { name: 'garages', label: 'Cocheras' },
  { name: 'toilettes', label: 'Toilettes' },
];

// Rangos de medidas en m² (mín/máx independientes).
export const MEASURE_FIELDS = [
  { min: 'minTotalSquareMeters', max: 'maxTotalSquareMeters', label: 'Superficie total (m²)' },
  { min: 'minCoveredSquareMeters', max: 'maxCoveredSquareMeters', label: 'Superficie cubierta (m²)' },
  { min: 'minSemiCoveredSquareMeters', max: 'maxSemiCoveredSquareMeters', label: 'Superficie semicubierta (m²)' },
  { min: 'minUncovered', max: 'maxUncovered', label: 'Superficie descubierta (m²)' },
  { min: 'minLand', max: 'maxLand', label: 'Terreno (m²)' },
];

// Grupos booleanos (checkboxes). value = clave exacta que entiende el backend.
export const AMENITIES_OPTIONS = [
  { value: 'pileta', label: 'Pileta' },
  { value: 'piletaClimatizada', label: 'Pileta climatizada' },
  { value: 'piletaCubierta', label: 'Pileta cubierta' },
  { value: 'aireAcondicionado', label: 'Aire acondicionado' },
  { value: 'calefaccion', label: 'Calefacción' },
  { value: 'losaRadiante', label: 'Losa radiante' },
  { value: 'chimenea', label: 'Chimenea' },
  { value: 'hidromasaje', label: 'Hidromasaje' },
  { value: 'gimnasio', label: 'Gimnasio' },
  { value: 'seguridad', label: 'Seguridad' },
  { value: 'ascensor', label: 'Ascensor' },
  { value: 'portonAutomatico', label: 'Portón automático' },
  { value: 'salonUsosMultiples', label: 'Salón de usos múltiples' },
  { value: 'solarium', label: 'Solárium' },
  { value: 'sauna', label: 'Sauna' },
  { value: 'laundry', label: 'Laundry' },
  { value: 'estacionamientoVisitas', label: 'Estacionamiento de visitas' },
  { value: 'areasVerdes', label: 'Áreas verdes' },
];

export const CHARACTERISTICS_OPTIONS = [
  { value: 'amoblado', label: 'Amoblado' },
  { value: 'placard', label: 'Placard' },
  { value: 'parilla', label: 'Parrilla' },
  { value: 'desayunador', label: 'Desayunador' },
  { value: 'deck', label: 'Deck' },
  { value: 'baulera', label: 'Baulera' },
  { value: 'sotano', label: 'Sótano' },
  { value: 'biblioteca', label: 'Biblioteca' },
  { value: 'galpon', label: 'Galpón' },
  { value: 'permiteMascota', label: 'Permite mascotas' },
  { value: 'aptoTuristico', label: 'Apto turístico' },
];

export const SERVICES_OPTIONS = [
  { value: 'electricidad', label: 'Electricidad' },
  { value: 'agua', label: 'Agua' },
  { value: 'gas', label: 'Gas' },
  { value: 'internet', label: 'Internet' },
  { value: 'telefono', label: 'Teléfono' },
  { value: 'desagueCloacal', label: 'Desagüe cloacal' },
  { value: 'televisionPorCable', label: 'TV por cable' },
  { value: 'televisionSatelital', label: 'TV satelital' },
  { value: 'alarma', label: 'Alarma' },
  { value: 'aguaCorriente', label: 'Agua corriente' },
];

export const ENVIRONMENTS_OPTIONS = [
  { value: 'dormitorio', label: 'Dormitorio' },
  { value: 'comedor', label: 'Comedor' },
  { value: 'living', label: 'Living' },
  { value: 'cocinaEnv', label: 'Cocina' },
  { value: 'vestidor', label: 'Vestidor' },
  { value: 'jardin', label: 'Jardín' },
  { value: 'patio', label: 'Patio' },
  { value: 'terraza', label: 'Terraza' },
  { value: 'balcon', label: 'Balcón' },
  { value: 'estudio', label: 'Estudio' },
  { value: 'lavadero', label: 'Lavadero' },
  { value: 'quincho', label: 'Quincho' },
  { value: 'playroom', label: 'Playroom' },
  { value: 'toiletteEnv', label: 'Toilette' },
];

// Configuración de los grupos booleanos para renderizar el panel avanzado.
export const BOOLEAN_GROUP_CONFIG = [
  { key: 'amenities', title: 'Amenities', options: AMENITIES_OPTIONS },
  { key: 'characteristics', title: 'Características', options: CHARACTERISTICS_OPTIONS },
  { key: 'services', title: 'Servicios', options: SERVICES_OPTIONS },
  { key: 'environmentsOptions', title: 'Ambientes', options: ENVIRONMENTS_OPTIONS },
];

// Opciones de conteo para los selects (1..6+).
export const COUNT_VALUE_OPTIONS = ['1', '2', '3', '4', '5', '6'];
